// All of the requested modules are loaded behind enumerable getters.
const map = Object.defineProperties({}, {
  "./(auth)/_layout.tsx": { enumerable: true, get() { return require("/home/kuzbekov/buskinapp/app/(auth)/_layout.tsx"); } },
  "./(auth)/login.tsx": { enumerable: true, get() { return require("/home/kuzbekov/buskinapp/app/(auth)/login.tsx"); } },
  "./(auth)/login.web.tsx": { enumerable: true, get() { return require("/home/kuzbekov/buskinapp/app/(auth)/login.web.tsx"); } },
  "./(root)/(tabs)/Buskers.tsx": { enumerable: true, get() { return require("/home/kuzbekov/buskinapp/app/(root)/(tabs)/Buskers.tsx"); } },
  "./(root)/(tabs)/Feed.tsx": { enumerable: true, get() { return require("/home/kuzbekov/buskinapp/app/(root)/(tabs)/Feed.tsx"); } },
  "./(root)/(tabs)/Places.tsx": { enumerable: true, get() { return require("/home/kuzbekov/buskinapp/app/(root)/(tabs)/Places.tsx"); } },
  "./(root)/(tabs)/Profile.tsx": { enumerable: true, get() { return require("/home/kuzbekov/buskinapp/app/(root)/(tabs)/Profile.tsx"); } },
  "./(root)/(tabs)/Subs.tsx": { enumerable: true, get() { return require("/home/kuzbekov/buskinapp/app/(root)/(tabs)/Subs.tsx"); } },
  "./(root)/(tabs)/_layout.tsx": { enumerable: true, get() { return require("/home/kuzbekov/buskinapp/app/(root)/(tabs)/_layout.tsx"); } },
  "./(root)/_layout.tsx": { enumerable: true, get() { return require("/home/kuzbekov/buskinapp/app/(root)/_layout.tsx"); } },
  "./(root)/busker-create.tsx": { enumerable: true, get() { return require("/home/kuzbekov/buskinapp/app/(root)/busker-create.tsx"); } },
  "./(root)/busker-details.tsx": { enumerable: true, get() { return require("/home/kuzbekov/buskinapp/app/(root)/busker-details.tsx"); } },
  "./(root)/comments.tsx": { enumerable: true, get() { return require("/home/kuzbekov/buskinapp/app/(root)/comments.tsx"); } },
  "./(root)/place-create.tsx": { enumerable: true, get() { return require("/home/kuzbekov/buskinapp/app/(root)/place-create.tsx"); } },
  "./(root)/place-details.tsx": { enumerable: true, get() { return require("/home/kuzbekov/buskinapp/app/(root)/place-details.tsx"); } },
  "./(root)/post-create.tsx": { enumerable: true, get() { return require("/home/kuzbekov/buskinapp/app/(root)/post-create.tsx"); } },
  "./(root)/post-details.tsx": { enumerable: true, get() { return require("/home/kuzbekov/buskinapp/app/(root)/post-details.tsx"); } },
  "./_layout.tsx": { enumerable: true, get() { return require("/home/kuzbekov/buskinapp/app/_layout.tsx"); } },
  "./index.tsx": { enumerable: true, get() { return require("/home/kuzbekov/buskinapp/app/index.tsx"); } },
});

function metroContext(request) {
    return map[request];
}

// Return the keys that can be resolved.
metroContext.keys = function metroContextKeys() {
  return Object.keys(map);
};

// Return the module identifier for a user request.
metroContext.resolve = function metroContextResolve(request) {
  throw new Error('Unimplemented Metro module context functionality');
}

module.exports = metroContext;